export const DetailItem = ({ icon, title, value, background, wrapperStyles, htmlText, underLine }) => {
    return (
        <div className="detail-item-wrapper" style={background ? { background: background, ...wrapperStyles } : { ...wrapperStyles }}>
            {icon && <img src={icon} alt="icon" className="detail-icon" />}

            {underLine ? (
                <p>
                    <span className="detail-title">{title ? `${title}:` : ''}</span>
                    <span className={htmlText ? 'description-convertor' : 'detail-value'}>{value}</span>
                </p>
            ) : (
                <>
                    <p className="detail-title">{title ? `${title}:` : ''} </p>
                    <p className={htmlText ? 'description-convertor' : 'detail-value'}>{value}</p>
                </>
            )}
        </div>
    );
};
